import { NextPage } from "next"
import Head from "next/head"
import { DefaultLayout } from "src/components/Layout"
import { ForFinancePaymentList } from "src/features/for-finance-payment/components/ForFinancePaymentList"

const ForFinancePaymentsPage: NextPage = () => (
  <DefaultLayout>
    <Head>
      <title>For Finance Payments | for Smoother</title>
    </Head>
    <div data-smooth-ds className="min-h-screen bg-bg-subtle">
      <div className="mx-auto px-4 py-6">
        <ForFinancePaymentList />
      </div>
    </div>
  </DefaultLayout>
)

export default ForFinancePaymentsPage
